import type { LeadPipelineType } from '@ekhodealer/ekho-common';

import { TextCell } from '@common/components/TextCell';

interface PipelineCellProps {
	pipeline: {
		type: LeadPipelineType;
		name: string;
	};
}

export const PipelineCell = ({ pipeline }: PipelineCellProps) => {
	return <TextCell value={pipeline.name} />;
};
